/**
 * A campaign holds a template reference, but a template can be deactivated at
 * any time after the draft is written. Send rejects that at the last moment, so
 * these helpers surface it earlier -- in the list, the editor, and the send
 * modal -- rather than letting it fail after the admin has committed.
 *
 * The FK on email_campaigns.template_id has no ON DELETE clause, so a template
 * in use cannot be deleted. Inactive is the only state to guard against.
 */

/** True when the campaign's template has been deactivated since the draft was written. */
export function hasInactiveTemplate(campaign) {
  return campaign?.template_is_active === false;
}

/** True for campaigns that have not gone out yet, where the warning still matters. */
export function isUnsent(campaign) {
  return campaign?.status === 'draft' || campaign?.status === 'scheduled';
}

/** True when the warning is worth showing: unsent, and the template is inactive. */
export function shouldWarnInactiveTemplate(campaign) {
  return isUnsent(campaign) && hasInactiveTemplate(campaign);
}

export const INACTIVE_TEMPLATE_MESSAGE =
  'This campaign’s template is inactive. Reactivate it or choose a different template before sending.';
